<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                {{ 'PASSWORD_MODAL_HEADER' | translate }}
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<form method="get"
      #f="ngForm"
      role="form"
      novalidate
      class="ion-padding">
    <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding">
            <ion-item class="ion-no-padding">
                <ion-input type="password"
                           placeholder="{{ 'CHAT_GROUP_PASSWORD_PLACEHOLDER' | translate }}"
                           name="password"
                           #password="ngModel"
                           [(ngModel)]="passwordValue"
                           required>
                </ion-input>
            </ion-item>
        </ion-col>
    </ion-row>
    <ion-row class="ion-no-padding">
        <ion-col class="ion-no-padding ion-text-right">
            <ion-button class="btn-close"
                        color=""
                        (click)="close()">
                {{ 'BUTTON_CANCEL' | translate }}
            </ion-button>
            <ion-button color="primary"
                        [disabled]="!passwordValue"
                        (click)="join(f.form.valid)">
                {{ 'BUTTON_JOIN' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</form>